// 搜尋結果卡片樣式
import { PlaceWithServices } from '../../../models/Place.ts';
import { Badge, Paper, Text } from '@mantine/core';
import {
  getServiceColor,
  getServiceLabel,
} from '../../../const/service_type_mapping.ts';
import { getPublishStatusColor } from '../../../const/place_publish_status_mapping.ts';
import React from 'react';

interface SpotlightSearchCardProps {
  place: PlaceWithServices;
  onClick: () => void;
}

const KeywordsSearchResultCard: React.FC<SpotlightSearchCardProps> = ({
  place,
  onClick,
}) => {
  return (
    <Paper
      p="16"
      withBorder
      style={{
        cursor: 'pointer',
        transition: '0.2s',
        backgroundColor: '#FFFFFF1A',
        border: '1px solid #DEE2E6',
        width: 500,
        borderRadius: 8,
      }}
      onClick={onClick}
    >
      <div style={{ position: 'relative' }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            position: 'relative',
            justifyContent: 'space-between',
            height: 20,
          }}
        >
          {/* 地點名稱 & 狀態 */}
          <Text fz={16} fw={700} pr={15} truncate={'end'}>
            {place.name}
          </Text>
          <div
            style={{
              width: '6px',
              height: '6px',
              borderRadius: '50%',
              backgroundColor: `${getPublishStatusColor(place.publishStatus)}`,
            }}
          />
        </div>

        {/* 地址 */}
        <Text
          truncate={'end'}
          fz={14}
          fw={400}
          c="dimmed"
          style={{ height: 20, alignContent: 'center' }}
          mt={6}
          mb={10}
          h={20}
        >
          {place.address}
        </Text>

        {/* 服務: 2 per row */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            columnGap: 8,
            rowGap: 8,
            width: '100%',
          }}
        >
          {place.services.map((service, index) => (
            <div
              key={index}
              style={{
                width: 230,
                display: 'flex',
                alignItems: 'center',
                gap: 8,
              }}
            >
              <Badge
                size="xs"
                variant="light"
                style={{
                  width: 54,
                  height: 16,
                  backgroundColor: `${getServiceColor(service.serviceType)}`,
                  color: 'black',
                  fontSize: 10,
                  padding: '2px 5px',
                  borderRadius: 10,
                  fontWeight: 600,
                }}
              >
                {getServiceLabel(service.serviceType)}
              </Badge>
              <Text
                truncate={'end'}
                style={{
                  width: 167,
                  fontSize: 12,
                  lineHeight: '16px',
                  fontWeight: 400,
                  maxWidth: 228,
                  maxHeight: 16,
                }}
              >
                {service.name}
              </Text>
            </div>
          ))}
        </div>
      </div>
    </Paper>
  );
};

export default KeywordsSearchResultCard;
